"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownWithLabel = exports._DropdownWithLabel = void 0;
var react_1 = __importDefault(require("react"));
var ErrorMessage_1 = require("../../../utils/ErrorMessage");
var with_form_manager_1 = require("../../../utils/with-form-manager");
var dropdown_component_1 = require("../../base/dropdown/dropdown-component");
var form_field_set_component_1 = require("../../base/form-field-set/form-field-set-component");
var label_component_1 = require("../../base/label/label-component");
var _DropdownWithLabel = function (_a) {
    var _b = _a.formFieldSetProps, formFieldSetProps = _b === void 0 ? {} : _b, _c = _a.dropdownProps, dropdownProps = _c === void 0 ? {} : _c, _d = _a.labelProps, labelProps = _d === void 0 ? {} : _d, id = _a.id, name = _a.name, children = _a.children, tooltip = _a.tooltip, formManagerProps = __rest(_a, ["formFieldSetProps", "dropdownProps", "labelProps", "id", "name", "children", "tooltip"]);
    var labelRef = react_1.default.useRef(null);
    var dropdownRef = react_1.default.useRef(null);
    var isFocused = true;
    // const isLabelFocused = useTrackFocus(labelRef);
    // const isDropdownFocused = useTrackFocus(dropdownRef);
    // const isFocused =
    //   isLabelFocused ||
    //   isDropdownFocused ||
    //   Boolean(dropdownRef?.current?.value?.trim()) ||
    //   Boolean(formManagerProps?.value?.trim());
    var error = formManagerProps.error, errorMessage = formManagerProps.errorMessage, extraDropdownProps = __rest(formManagerProps, ["error", "errorMessage"]);
    // let content = children;
    // if (tooltip) {
    //   content = (
    //     <div className="flex justify-between w-full">
    //       <span className="mr-2">{children}</span>
    //       <Tooltip placement="top" overlay={<span>{tooltip}</span>}>
    //         <HelpCircle
    //           size={isFocused ? 16 : 20}
    //           className={`opacity-50 hover:opacity-100 ${
    //             !isFocused ? "mr-5" : ""
    //           }`}
    //         />
    //       </Tooltip>
    //     </div>
    //   );
    // }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_field_set_component_1.FormFieldSet, __assign({}, formFieldSetProps, { hasError: error }),
            react_1.default.createElement(label_component_1.Label, __assign({ htmlFor: id, ref: labelRef, isFocused: isFocused }, labelProps, { hasError: error }),
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement("span", { className: "block" }, children),
                    tooltip && (react_1.default.createElement("span", { className: "block fs12 font-light mt-1 translate" }, tooltip)))),
            react_1.default.createElement(dropdown_component_1.Dropdown, __assign({ id: id, name: name, ref: dropdownRef, isFocused: isFocused, style: isFocused ? undefined : { color: "transparent" }, hasError: error }, dropdownProps, extraDropdownProps))),
        errorMessage && react_1.default.createElement(ErrorMessage_1.ErrorMessage, null, errorMessage)));
};
exports._DropdownWithLabel = _DropdownWithLabel;
// const base = "fs14 w-full bg-white border-0 rounded-md block outline-none";
// const notFocused = "p-3";
// const focus = "pl-3 pb-2 pr-3";
// const getClasses = ({ isFocused }: { isFocused: boolean }) => {
//   return classNames(base, {
//     [focus]: isFocused,
//     [notFocused]: !isFocused,
//   });
// };
exports.DropdownWithLabel = Object.assign(exports._DropdownWithLabel, {
    css: {
    // base,
    // notFocused,
    // focus,
    },
    WithFormManager: (0, with_form_manager_1.withFormManager)(exports._DropdownWithLabel),
    displayName: "VistoDropdownWithLabel",
});
